import Ajax from "base/Ajax";
import Message from "base/Message";
import Modal from "modal/Modal";
import "gallery/image/GalleryItemImage";
import "gallery/video/GalleryItemVideo";
import GalleryItem from "gallery/GalleryItem";
import AddVideoModal from "gallery/video/AddVideoModal";
import AddImageModal from "gallery/image/AddImageModal";

class Gallery extends Modal {

    constructor(id = null, profile = '1' /*Default*/) {
        super({class: "admin-modal--navigation"});
        this.loading = true;
        this._id = id;
        this.items = [];
        this.shown = false;
        this.data = null;
        this.$content = eotwJSXFactory('div', {class: "admin-gallery"});

        this.$draggingElement = null;
        this.$originalElement = null;

        this.onDragStart = this.onDragStart.bind(this);
        this.onDrag = this.onDrag.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);

        if (id !== null) {
            this.load();
        } else {
            this.data = {};
            this.loadProfile(profile)
        }

        this.bindEvents();
    }

    static get_profiles() {
        if (!this.get_profiles_request) {
            this.get_profiles_request = Ajax.get("gallery", "profiles");
        }
        return this.get_profiles_request;
    }

    destroy() {
        super.destroy();
        $(window).off("mousemove", this.onDrag).off("mouseup", this.onDragEnd);
    }

    bindEvents() {
        const me = this;
        this.$content.on("click", ".js-add-item", () => {
            if (this.data.profile.allowImages) {
                this.showAddImage();
            } else if (this.data.profile.allowVideos) {
                this.showAddVideo();
            } else {
                //Can't do anything...
            }

            return false;
        });
        this.$content.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.hide();
            return false;
        });
        this.$content.on("mousedown", ".js-item", this.onDragStart);
        $(window).on("mousemove", this.onDrag).on("mouseup", this.onDragEnd);

        this.$content.on("click", ".js-save", function () {
            let $btn = $(this);
            if ($btn.is(".admin-btn--loading")) return false;
            $btn.addClass("admin-btn--loading");

            me.save().then(() => {
                me.hide();
                let event = new Event("galleryUpdated");
                event.gallery = me;
                window.document.dispatchEvent(event);
            }).catch((e) => {
                $btn.removeClass("admin-btn--loading");
                console.log(e);
                new Message(e.message, "Couldn't save the gallery")
            })
        });
        this.$content.on("click", ".js-item .js-edit", function () {
            let item = $(this).parents(".js-item").data("item");

            let modal = item.getModal();

            modal.on("cancel okay", () => {
                modal.destroy();
                me.show();
            });

            modal.show();
            return false;
        }).on("click", ".js-item .js-remove", function () {
            let item = $(this).parents(".js-item").data("item");
            me.items = me.items.filter((_item) => _item !== item);
            me.updateContent();
            return false;
        });
    }

    save() {
        let promises = this.items.map((item) => item.save());

        return Promise.all(promises).then(() => {
            return new Promise((resolve, reject) => {
                let data = {
                    items: this.items.map((item) => item.data.id),
                    profile: this.data.profile.id
                };

                let request;

                if (this._id === null) {
                    request = Ajax.post("gallery", "", data)
                } else {
                    request = Ajax.post(null, this.data.href, data);
                }

                request.then((data) => {
                    this._id = data.id;
                    this.data = data;
                    this.items = data.items.map((item) => GalleryItem.process_item(this, item));
                    this.emit("saved");

                    this.updateContent();
                    resolve(data);
                }).catch(reject)
            })
        })
    }

    updateContent() {
        this.emit("update", {items: this.items});
        if (!this.shown) return;
        if (this.loading) {
            this.showLoading();
        } else {

            this.$content.html([
                eotwJSXFactory('div', {class: "admin-modal__navigation"}, [
                    eotwJSXFactory('button', {class: "admin-modal__link admin-modal__link--active"}, ["Gallery"])
                ]),
                eotwJSXFactory('div', {class: "admin-modal__content"}, [
                    eotwJSXFactory('h2', null, ["Media Gallery"]),
                    eotwJSXFactory('div', {class: "admin-gallery__items"}, [
                        this.items.map((item) => item.getElement()),
                        this.getAddItemElement(),
                        this.getItemPlaceholders()
                    ]),
                    eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                        eotwJSXFactory('button', {class: "js-cancel admin-btn admin-btn--cancel admin-btn--right"}, ["Cancel"]),
                        eotwJSXFactory('button', {class: "js-save admin-btn admin-btn--confirm admin-btn--right"}, ["Save"])
                    ])
                ])
            ]);
        }
    }

    getAddItemElement() {
        let allowMoreItems = this.data.profile.maxItems === null || this.items.length < this.data.profile.maxItems;

        return (
            eotwJSXFactory('button', {type: "button", class: "admin-gallery__item-wrap admin-gallery__item-wrap--btn js-add-item " + (allowMoreItems ? "" : "admin-btn--disabled"), disabled: !allowMoreItems})
        )
    }

    getItemPlaceholders() {
        let placeholders = [];
        for (let i = 4 - (this.items.length + 1) % 4; i > 0 && i !== 4; i--) {
            placeholders.push(eotwJSXFactory('div', {class: "admin-gallery__item-wrap"}));
        }
        return placeholders;
    }

    showLoading() {
        this.$content.html("<div class='admin-modal__loading'><svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#main-loading'></use></svg></div>")
    }

    onDragStart(e) {
        if ($(e.target).is("button") || $(e.target).parents("button").length !== 0) return;
        let $originalElement = this.$originalElement = $(e.currentTarget);
        let $element = this.$draggingElement = $originalElement.clone();

        $originalElement.addClass("admin-gallery__item-wrap--placeholder");
        $element.addClass("admin-gallery__item-wrap--dragging");

        $originalElement.after($element);

        this.onDrag(e);
        return false;
    }

    onDragEnd(e) {
        if (this.$draggingElement !== null) {
            this.$originalElement.removeClass("admin-gallery__item-wrap--placeholder");
            this.$draggingElement.remove();

            this.$draggingElement = null;
            this.$originalElement = null;

            e.preventDefault();
            return false;
        }
    }

    onDrag(e) {
        if (this.$draggingElement !== null) {
            let top = e.pageY - this.$draggingElement.parent().offset().top - (this.$draggingElement.height() / 2);
            let left = e.pageX - this.$draggingElement.parent().offset().left - (this.$draggingElement.width() / 2);
            this.$draggingElement.css({top: top, left: left});

            let currentIndex = this.$originalElement.index();
            this.$content.find(".js-item").each((index, el) => {
                let $el = $(el);
                if ($el.is(".admin-gallery__item-wrap--placeholder") || $el.is(".admin-gallery__item-wrap--dragging")) return;

                let offset = $el.offset();
                offset.right = offset.left + $el.outerWidth();
                offset.bottom = offset.top + $el.outerHeight();

                if ((offset.left < e.pageX && e.pageX < offset.right) && (offset.top < e.pageY && e.pageY < offset.bottom)) {
                    if (currentIndex > index) {
                        $el.before(this.$originalElement);
                    } else {
                        $el.after(this.$originalElement);
                    }
                    this.items = this.$content.find(".js-item").map(function () {
                        return $(this).data("item");
                    }).get();

                    return false;
                }
            });
        }
    }

    showAddImage() {
        let shown = this.shown;
        let modal = new AddImageModal(this);

        return new Promise((resolve, reject) => {
            modal.on("cancel", () => {
                if (shown) {
                    this.show();
                } else {
                    this.updateContent();
                }
                modal.destroy();
                reject();
            }).on("images", (images) => {
                this.items.push.apply(this.items, images);
                if (shown) {
                    this.show();
                } else {
                    this.updateContent();
                }
                modal.destroy();
                resolve();
            });
        });
    }

    showAddVideo() {
        let shown = this.shown;
        let modal = new AddVideoModal(this);
        return new Promise((resolve, reject) => {

            modal.on("cancel", () => {
                if (shown) {
                    this.show();
                } else {
                    this.updateContent();
                }
                modal.destroy();
                reject();
            }).on("videos", (videos) => {
                this.items.push.apply(this.items, videos);
                if (shown) {
                    this.show();
                } else {
                    this.updateContent();
                }
                modal.destroy();
                resolve();
            });
        });
    }

    load() {
        this.loading = true;
        return Ajax.get("gallery", this._id, {depth: 10}).then((data) => {
            this.loading = false;
            this.data = data;
            this.items = data.items.map((item) => GalleryItem.process_item(this, item));
            this.emit("load");
            this.updateContent();
        }).catch((e) => {
            console.error(e);
            new Message(e.message, "Couldn't load the gallery");
        })
    }

    loadProfile(profile) {
        this.loading = true;
        return Gallery.get_profile(profile).then((data) => {
            this.loading = false;
            this.data.profile = data;

            this.updateContent();
        }).catch((e) => {
            console.error(e);
            new Message(e.message, "Couldn't load the gallery");
        })
    }

    show() {
        super.show();
        this.updateContent();

        return this;
    }

    static get_profile(profile) {
        if (!Gallery.profile_cache) Gallery.profile_cache = {};

        if ('undefined' !== typeof Gallery.profile_cache[profile]) return Gallery.profile_cache[profile];

        return Gallery.profile_cache[profile] = Ajax.get("gallery", "profiles/" + profile);
    }
}

export default Gallery;
